import styles from './FileIcon.module.scss';

interface IFileIconProps {
  fileName: string;
  fileType?: string;
}

export const FileIcon = ({ fileName, fileType }: IFileIconProps) => {
  const mapIconPath: Record<string, string> = {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/msword': 'doc',
    'image/jpeg': 'jpeg',
    'application/pdf': 'pdf',
    'image/png': 'png',
    'application/zip': 'zip',
    'application/x-zip-compressed': 'zip',
    'application/x-rar': 'rar',
  };

  let iconStyle: string | undefined;

  if (fileType) {
    iconStyle = mapIconPath[fileType];
  } else {
    const fileExtension = fileName.split('.').pop();
    iconStyle = fileExtension;
  }

  return (
    <div className={styles.DocumentIcon}>
      <div className={iconStyle && styles[iconStyle]} />
    </div>
  );
};
